import { Form } from 'types/form'

const HANDICAP_FORM: Form = [
  [
    {
      name: 'principalReport',
      type: 'textarea',
      label: 'Origine du handicap',
      placeholder: 'Précisez',
      required: true,
    },
  ],
]

export default HANDICAP_FORM
